'use client';

import Link from 'next/link';
import { trackEvent } from '../../lib/analytics/posthog';
import { EVENTS } from '../../lib/analytics/events';

export default function Breadcrumbs({ items }) {
  if (!items || items.length === 0) return null;

  return (
    <nav className="flex flex-wrap items-center gap-1.5 text-[12px] text-gray-400 mb-6">
      {items.map((item, i) => {
        const isLast = i === items.length - 1;
        return (
          <span key={i} className="flex items-center gap-1.5">
            {i > 0 && <span>/</span>}
            {isLast || !item.href ? (
              <span className="text-gray-600 font-medium">{item.label}</span>
            ) : (
              <Link href={item.href} className="hover:text-primary-500 transition-colors" onClick={() => trackEvent(EVENTS.NAV_BREADCRUMB_CLICKED, { level: i, text: item.label })}>
                {item.label}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}
